var myConfig = {
    //apiUrl:"http://localhost:5000/"
    apiUrl: "https://organizarclientes-github.herokuapp.com/",
}
 
module.exports = myConfig;